// patrones
export const regex_dec = /^[0-9]*\.?[0-9]*$/; // acepta números decimales / precios
export const regex_num = /^[0-9\b]+$/; // acepta números
export const regex_no_num = /^([^0-9]*)$/; // NO acepta números
export const regex_phone = /^(?!(\d{2,})\1+)(?!(\d+)\2{3,})(\+\d{1,3})?(\d{9,10})$/;
// correos electrónicos
export const regex_email = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
// obtener extensión de archivo
export const regex_file_ext = /(?:\.([^.]+))?$/;